import { NavigationParams } from "../utils/navigation";
import { NavigationDataResponse } from "../types/navigation";
import { fetchEventSource } from '@microsoft/fetch-event-source';

export const BASE = process.env.REACT_APP_BASE_URL || "";
// export const API_ENDPOINT_CHAT = "/chat";
export const API_ENDPOINT_CHAT = "/food-expo-2026/0.0.2/chat";
// const API_ENDPOINT_LOCATION = "/identify-location";

// export async function findStartPoi(
//   query: string,
//   venueId: string,
//   traceId: string
// ) {
//   const parameter = {
//     query: query,
//     venue_id: venueId,
//     trace_id: traceId,
//   };
//   console.log("params", parameter);
//   const url = new URL(API_ENDPOINT_LOCATION, BASE);
//   const res = await fetch(url.toString(), {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(parameter),
//   });

//   if (!res.ok) throw new Error(`Failed: ${res.status}`);
//   return (await res.json()) as StartLocationJson;
// }

// export async function findPath(params: NavigationParams) {
//   const parameter = {
//     query: params.userQuery,
//     conversation_id: params.conversationId,
//     trace_id: params.traceId,
//     user_id: params.userId,
//     venue_id: params.venueId,
//     lat: params.userLocation?.lat.toString(),
//     lng: params.userLocation?.lng.toString(),
//     map_id: params.mapId.toString(),
//     is_disability: params.is_disability,
//     lang: params.lang === "en" ? "en" : "zh_HK",
//   };
//   console.log("params", parameter);
//   const url = new URL(API_ENDPOINT_CHAT, BASE);
//   const res = await fetch(url.toString(), {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(parameter),
//   });

//   if (!res.ok) throw new Error(`Failed: ${res.status}`);
//   return (await res.json()) as NavigationData;
// }

export async function fetchPath(
  params: NavigationParams,
  onChunk?: (chunk: string) => void,
  signalController?: AbortController): Promise<NavigationDataResponse> {

  const url = new URL(API_ENDPOINT_CHAT, BASE).toString();
  let endEventReceived = false;

  console.log(`current location ${params.userLocation?.lat}, ${params.userLocation?.lng}`)
  console.log(`mode: ${params.is_disability}`)
  console.log(`start POI: ${params.startPoi}`)
  let locationQuery = ""
  if (params.userLocation != null) {
    if (params.startPoi != null) {
      locationQuery = `I am near ${params.startPoi}.`
    }
  }

  let modeQuery = ""
  if (params.is_disability == "1") {
    modeQuery = "I am disabled."
  }

  const finalQuery = `${locationQuery} ${modeQuery} ${params.userQuery}`
  console.log(`finalQuery: ${finalQuery}`)
  return new Promise((resolve, reject) => {
    console.log("fetch url", url)
    fetchEventSource(url, {
      signal: signalController?.signal,
      method: 'POST',
      body: JSON.stringify({
        query: finalQuery,
        trace_id: params.traceId,
        user_id: params.userId,
        lang: params.lang === 'en' ? 'en' : 'zh_HK',
        lat: params.userLocation?.lat.toString(),
        lng: params.userLocation?.lng.toString()
      }),
      headers: { 'Content-Type': 'application/json' },

      onopen: async (response) => {
        if (!response.ok) {
          throw new Error(`Unexpected response: ${response.status}`);
        }
      },

      onmessage(event) {
        try {
          if (!event.data || event.data.startsWith(':')) return;

          const parsed = JSON.parse(event.data);
          console.log("parsed", parsed)
          if (parsed.event === 'update') {
            onChunk?.(parsed.data.message);
          } else if (parsed.event === 'end') {
            endEventReceived = true;
            resolve(parsed.data);
            signalController?.abort();
          }
        } catch {
          console.warn('Failed to parse SSE data:', event.data);
          reject(new Error('Error parsing data'));
        }
      },

      onclose() {
        if (endEventReceived) {
          return;
        }
        // Server closed unexpectedly without sending 'end'
        reject(new Error('Stream closed unexpectedly'));
      },

      onerror(err) {
        reject(err);
        // throw err;
      },
    });
  });

}